import type { QuoterTranslations } from "../interfaces/quoter";

export const quoterTranslations: QuoterTranslations = {
  header_title: "Cotizador de envíos",
  header_subtitle: "Calcula tus transferencias internacionales al instante.",
  header_history_button: "Historial",
  step1_title: "Paso 1: ¿Qué deseas hacer?",
  step1_send_title: "Quiero enviar",
  step1_send_description: "Enviar dinero a otra moneda",
  step1_receive_title: "Quiero recibir",
  step1_receive_description: "Calcular cuánto debo pagar",
  step1_rate_label: "Tasa de cambio actual",
  step1_equiv_to: "equivale a",
  step1_quote_to_see_rate: "Cotiza para ver la tasa",
  step2_title: "Paso 2: Detalles del envío",
  step2_origin_label: "Moneda de Origen",
  step2_destination_label: "Moneda de Destino",
  step2_select_currency: "Seleccionar moneda",
  step2_amount_send: "Cantidad a enviar",
  step2_amount_receive: "Cantidad a recibir",
  step2_amount_placeholder: "Ej: 1.000.000",
  step2_commission_label: "Comisión (%)",
  form_error_select_currencies: "Selecciona moneda de origen y destino.",
  form_error_valid_amount: "Ingresa una cantidad válida.",
  form_error_country_not_found: "No se encontró país para la moneda seleccionada.",
  form_error_quote: "Error al obtener la cotización.",
  form_button_quoting: "Cotizando…",
  form_button_submit: "Cotizar envío ahora",
  summary_total_pay: "Total a pagar",
  summary_commission_suffix: "de comisión ({{percent}}%)",
  summary_amount_converted: "Monto convertido",
  summary_beneficiary_receives: "Total que recibe el beneficiario",
  result_title: "Resultado de la Cotización",
  result_amount_sent: "Monto que envía",
  result_amount_received: "Monto que recibirá",
  result_amount_converted: "Monto Convertido",
  result_commission: "Comisión ({{percent}}%)",
  result_effective_rate_title: "Tasa Coloca",
  footer_secure: "Seguro",
  footer_instant: "Instantáneo",
  footer_copyright: "© 2024 Logística Global S.A. Todos los derechos reservados.",
  history_title: "Historial de cotizaciones",
  history_refresh: "Actualizar",
  history_back: "Regresar",
  history_no_permission: "No tienes permiso para ver el historial de cotizaciones.",
  history_filters_title: "Filtros",
  history_filters_origin: "Moneda origen",
  history_filters_destination: "Moneda destino",
  history_filters_all: "Todas",
  history_filters_start_date: "Fecha de inicio",
  history_filters_end_date: "Fecha de fin",
  history_filters_apply: "Aplicar Filtros",
  history_filters_clear: "Limpiar Filtros",
  history_table_showing_one: "Mostrando 1 cotización en esta página (Total: {{total}})",
  history_table_showing_many: "Mostrando {{count}} cotizaciones en esta página (Total: {{total}})",
  history_table_show_label: "Mostrar:",
  history_table_empty: "No hay cotizaciones para mostrar.",
  history_table_th_origin: "Origen",
  history_table_th_destination: "Destino",
  history_table_th_send: "Envía",
  history_table_th_receive: "Recibe",
  history_table_th_commission: "Comisión %",
  history_table_th_rate: "Tasa",
  history_table_th_created_by: "Creado por",
  history_table_th_date: "Fecha",
  history_table_th_actions: "Acciones",
  history_table_view_aria: "Ver cotización",
  history_table_view: "Ver",
  history_modal_title: "Detalle de la cotización",
  history_modal_close_aria: "Cerrar",
  history_modal_error_load: "No se pudo cargar el detalle de la cotización.",
  history_modal_amount_receive: "Monto que recibirá",
  history_modal_origin: "Origen",
  history_modal_destination: "Destino",
  history_modal_commission: "Comisión de transferencia ({{percent}}%)",
  history_modal_total_debit: "Total a debitar",
  history_modal_created_by: "Creado por:",
  history_modal_date: "Fecha:",
  history_modal_close_button: "Cerrar",

  history_pagination_records: "Registros del {{from}} al {{to}} de {{total}}",
  history_pagination_total_pages: "Total de páginas ({{lastPage}})",
  history_pagination_first_page: "Primera página",
  history_pagination_prev_page: "Página anterior",
  history_pagination_next_page: "Página siguiente",
  history_pagination_last_page: "Última página",
};
